import React from 'react';
import { Section } from './ui/Section';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <Section className="bg-transparent" data-id="element-62">
      <div className="max-w-4xl mx-auto bg-black/60 backdrop-blur-md border border-[#D4AF37]/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-2xl" data-id="element-63">
        <div className="relative z-10 flex flex-col items-center" data-id="element-64">
          <div className="w-20 h-20 bg-[#D4AF37]/20 rounded-full flex items-center justify-center mb-6" data-id="element-65">
            <ShieldCheck className="w-10 h-10 text-[#D4AF37]" data-id="element-66" />
          </div>

          <h2 className="text-3xl font-bold text-white mb-4 drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)]" data-id="element-67">
            Garantía de Hierro de 30 Días
          </h2>

          <p className="text-xl text-gray-100 max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-68">
            Prueba el Sistema AntiCaos PRO™ por 30 días. Si no ves resultados,
            si no sientes que tu disciplina está mejorando, te devolvemos tu
            dinero.
            <span className="block mt-2 font-semibold text-[#D4AF37]" data-id="element-69">
              Sin preguntas. Sin letra chica.
            </span>
          </p>
        </div>
      </div>
    </Section>;
}